export enum Answer {
  Yes = 'Y',
  No = 'N',
}
